module.exports = __webpack_public_path__ + "web3.png?1f64ed48c0430f9f1506f2841fb9e623";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/web3.png
// module id = 78
// module chunks = 0